import { useTheme } from '@mui/material';
import EntityCard, { EntityCardStat } from '../dashboard/entityCard';

type Props = { userAppInstance: any; openUserAppInstance: (userAppInstance: any) => void };

const UserAppInstanceIcon = ({ userAppInstance, openUserAppInstance }: Props) => {
  const theme = useTheme();

  const stats: EntityCardStat[] = [];

  if (userAppInstance?.usageStats) {
    const s = userAppInstance.usageStats;
    if (s.conversations !== undefined) stats.push({ label: 'chats', value: s.conversations });
    if (s.interactions?.interactions !== undefined) stats.push({ label: 'queries', value: s.interactions.interactions });
    if (s.dataSources !== undefined) stats.push({ label: 'sources', value: s.dataSources });
    if (s.sourceAgents !== undefined) stats.push({ label: 'agents', value: s.sourceAgents });
  }

  if (userAppInstance?.sourceEntities?.length > 0) {
    if (!stats.find(s => s.label === 'sources')) stats.push({ label: 'sources', value: userAppInstance.sourceEntities.length });
  }

  return (
    <EntityCard
      name={userAppInstance.name}
      type={userAppInstance?.userAppDef?.name || 'Application'}
      icon={userAppInstance?.userAppDef?.instanceIcon || 'screwdriver-wrench'}
      color={theme.palette.secondary.main}
      onClick={() => openUserAppInstance(userAppInstance)}
      statusLabel={userAppInstance.active !== false ? 'active' : 'inactive'}
      description={userAppInstance.description}
      stats={stats.length > 0 ? stats.slice(0, 4) : undefined}
      createdDate={userAppInstance.createdDate}
      lastUpdatedDate={userAppInstance.lastUpdatedDate}
    />
  );
};

export default UserAppInstanceIcon;
